

const mutations = {

    setDirectAccessVisibility(state, visible){
      state.productAuswahl.visible = visible;
    },

    setProductTreeVisibility(state, visible) {
      state.productAuswahl.isProductTreeVisible = visible;
    },

    setProductList(state, productList) {
      state.productAuswahl.productList = productList;
    },

    setIsTestDatabaseEnabled(state, isEnabled){
      state.isTestDatabaseEnabled = isEnabled;
    },

    setIsTestRulesEnabled(state, isEnabled){
        state.isTestRulesEnabled = isEnabled;
    },

    setProductBreadcrumb(state, productBreadcrumb){
      state.productAuswahl.productBreadcrumb = productBreadcrumb;
    },

    setProductSizes(state, productSizes) {
      state.productAuswahl.productSizes = productSizes;
    },

    setProductTree(state, productTree) {
      state.productAuswahl.productTree = productTree;
    },

    /**
     * Use this mutation for updating the KonfigModel after validation or any other
     * action that should not trigger a new validation.
     * @param state
     * @param konfigModel
     */
    setKonfigModelAfterRequest(state, konfigModel) {
        state.konfigModel = konfigModel;
    },
    /**
     * Change validation mode for the next request.
     * This call does not trigger a server-side konfigModel validation!
     * Modes are MERKMALE, TYPEN_SCHLUESSEL
     * @param state
     * @param mode
     */
    setKonfigModelValidationMode(state, mode) {
        let modes = ['MERKMALE', 'TYPEN_SCHLUESSEL'];
        if (modes.includes(mode)) {
            state.konfigModel.validationMode = mode;
        } else {
            console.error(mode + ' is not a valid validation mode. ' +
                'Please change to one of the following: ' + JSON.stringify(modes))
        }
    },
    setKonfigModel(state, konfigModel) {
        state.konfigModel = konfigModel;
    },
    // setKonfigModelSize(state, size) {
    //     state.konfigModel.groesse = size;
    // },
    setKonfigModelTypenschluessel(state, typenschluessel) {
        state.konfigModel.typenSchluessel = typenschluessel;
    },
    setSelectedMerkmal(state, payload) {
        payload.merkmal.selected = payload.value;
    },
    setSelectedOptionalesMerkmal(state, payload) {
        payload.optionaleMerkmale.selected = payload.value;
    },
    setSelectedAuswahlWert(state, payload) {
        let attribut = payload.attribut;
        attribut.selectedAuswahlWert = payload.value;
        attribut.selectedEingabeWert = null;
    },
    setSelectedEingabeWert(state, payload) {
        let attribut = payload.attribut;
        attribut.selectedEingabeWert = payload.value;
        attribut.selectedAuswahlWert = null;
    },
    resetGruppe(state, payload) {
        payload.gruppe.attribute.forEach((attribut) => {
            attribut.selectedAuswahlWert = null;
            attribut.selectedEingabeWert = null;
            attribut.eingabeWerte.forEach((eingabeWert) => {
                eingabeWert.value = '';
            });
        })
    },
    resetAttribut(state, payload) {
        let attribut = payload.attribut;
        attribut.selectedEingabeWert = null;
        attribut.selectedAuswahlWert = null;
    },

    setErrorMessage(state, errorMessage) {
        state.errorMessage = errorMessage;
        state.errorMessageDismissCountDown = 10;
    },

    dismissErrorMessage(state) {
        state.errorMessage = '';
        state.errorMessageDismissCountDown = 0;
    },

    setLoadingFlag(state, flag) {
        state.loadingIndicator.push(flag);
    },

    setDownloadFlag(state, flag) {
        state.downloadIndicator.push(flag);
    },

    removeDownloadFlag(state, flag) {
        let index = state.downloadIndicator.indexOf(flag);
        if (index !== -1) state.downloadIndicator.splice(index, 1);
    },

    removeLoadingFlag(state, flag) {
        let index = state.loadingIndicator.indexOf(flag);
        if (index !== -1) state.loadingIndicator.splice(index, 1); //Remove flag with splice()
    },

    setUserData(state, userData) {
        state.userData = userData;
    },

    setNotificationContent(state, payload) {
        state.notificationContent.variant = payload.variant;
        state.notificationContent.title = payload.title;
        state.notificationContent.text = payload.text;
        state.notificationContent.dontHide = payload.dontHide;
    },

    showNotification(state) {
        state.notification = 1;
    },

    removeNotification(state) {
        state.notification = 0;
    },

    setShowInquiryModal(state, payload) {
        state.isInquiryModalVisible = payload
        // this.set(state.requestInquiryModel, 'visible', payload.m)
        //state.requestInquiryModel.visible = payload.visible;
    },

    setShowQuotationModal(state, payload) {
        state.isQuotationModalVisible = payload
        // this.set(state.requestInquiryModel, 'visible', payload.m)
        //state.requestInquiryModel.visible = payload.visible;
    },

    newCsrfToken(state, response) {
        state.csrfToken = {
            'X-CSRF-TOKEN': response.headers['x-csrf-token'],
            'X-CSRF-PARAM': response.headers['x-csrf-param'],
            'X-CSRF-HEADER': response.headers['x-csrf-header']
        };
    },
    setValidating(state, payload) {
        state.validating = payload;
    },
    setSla(state, sla) {
        state.sla = sla;
    },
    getItemFeatures(state, itemFeatures) {
        state.itemFeatures = itemFeatures;
    },
    resetSla(state) {
        state.sla = {
            berechnungsStopp: null
        }
    }

};

export default mutations;